import { combineReducers } from 'redux';
import user from '../reducers/user'

let store = combineReducers(
		{ 
			user: user,
		}
	);
export default store;